var render = function render(_c,_vm){return _c('div',[(_vm.props.transition)?_c('transition-group',{staticClass:"row",class:[
            _vm.$options.getClassMap(_vm.props),
            _vm.data.class,
            _vm.data.staticClass
        ],attrs:{"tag":"div","name":_vm.props.transition,"mode":"out-in"}},[_vm._t("default")],2):_c('div',{staticClass:"row",class:[
            _vm.$options.getClassMap(_vm.props),
            _vm.data.class,
            _vm.data.staticClass
        ]},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }